import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/dot-sample.png'


const _hoisted_1 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_2 = { class: "relative w-full max-w-4xl max-h-[90vh] overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-xl dark:border-gray-700 dark:bg-black" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-4 md:grid-cols-2" }
const _hoisted_5 = { class: "rounded-lg bg-gray-50 p-4 dark:bg-gray-800" }
const _hoisted_6 = { class: "text-base font-medium text-gray-900 dark:text-white" }
const _hoisted_7 = { class: "rounded-lg bg-gray-50 p-4 dark:bg-gray-800" }
const _hoisted_8 = { class: "break-all text-base font-medium text-gray-900 dark:text-white" }
const _hoisted_9 = { class: "mb-6" }
const _hoisted_10 = { class: "rounded-lg bg-gray-50 p-4 dark:bg-gray-800" }
const _hoisted_11 = { class: "text-base font-medium text-gray-900 dark:text-white" }
const _hoisted_12 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_13 = { class: "mb-6" }
const _hoisted_14 = { class: "grid grid-cols-1 gap-4 md:grid-cols-2" }
const _hoisted_15 = { class: "rounded-lg bg-gray-50 p-4 dark:bg-gray-800" }
const _hoisted_16 = { class: "text-base font-medium text-gray-900 dark:text-white" }
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 0,
  class: "mt-1 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_19 = {
  key: 0,
  class: "mt-1 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_20 = {
  key: 0,
  class: "mt-1 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_21 = { class: "md:col-span-2" }
const _hoisted_22 = {
  for: "admin-dot",
  class: "mb-2 flex items-center justify-between text-sm font-medium text-gray-700 dark:text-gray-300"
}
const _hoisted_23 = {
  key: 0,
  class: "mt-3 rounded-lg border border-blue-200 bg-blue-50 p-4 dark:border-blue-800 dark:bg-blue-900/20"
}
const _hoisted_24 = {
  key: 0,
  class: "mt-1 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_25 = { class: "mb-6" }
const _hoisted_26 = { class: "grid grid-cols-1 gap-4 md:grid-cols-2" }
const _hoisted_27 = {
  key: 0,
  class: "mt-1 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_28 = {
  key: 0,
  class: "mt-1 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_29 = { class: "md:col-span-2" }
const _hoisted_30 = {
  key: 0,
  class: "mt-1 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_31 = { class: "mb-6" }
const _hoisted_32 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_33 = { class: "mb-2 text-sm font-medium text-gray-700 dark:text-gray-300" }
const _hoisted_34 = { class: "grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4" }
const _hoisted_35 = ["src"]
const _hoisted_36 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center rounded-lg bg-red-500 bg-opacity-20"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 1,
  class: "mt-2 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_40 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_41 = { class: "mb-2 text-sm font-medium text-gray-700 dark:text-gray-300" }
const _hoisted_42 = { class: "grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4" }
const _hoisted_43 = ["src", "alt"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "mb-6" }
const _hoisted_46 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_47 = { class: "mb-2 text-sm font-medium text-gray-700 dark:text-gray-300" }
const _hoisted_48 = { class: "grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4" }
const _hoisted_49 = ["src"]
const _hoisted_50 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center rounded-lg bg-red-500 bg-opacity-20"
}
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = {
  key: 1,
  class: "mt-2 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_54 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_55 = { class: "mb-2 text-sm font-medium text-gray-700 dark:text-gray-300" }
const _hoisted_56 = { class: "grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4" }
const _hoisted_57 = ["src", "alt"]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "sticky bottom-0 flex justify-end space-x-3 border-t border-gray-200 bg-white pt-4 dark:border-gray-700 dark:bg-black" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = ["disabled"]
const _hoisted_62 = {
  key: 0,
  class: "-ml-1 mr-2 h-4 w-4 animate-spin text-white",
  fill: "none",
  viewBox: "0 0 24 24"
}

import { computed, ref, watch } from 'vue';
import { useToast } from 'vue-toastification';
import { useBrand } from '@/composables/brand/useBrand';
import type { Tire } from '@/types/tire';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditAdminTireModal',
  props: {
    isOpen: { type: Boolean },
    tire: {},
    loading: { type: Boolean }
  },
  emits: ["close", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const toast = useToast();
const { brandColors } = useBrand();

const formData = ref({
  pattern: '',
  tire_size: '',
  dot: '',
  tire_position: '',
  shop: '',
  code: '',
  invoice_number: '',
});

const newTirePhotos = ref<File[]>([]);
const deletedTirePhotoIds = ref<number[]>([]);
const tirePhotoInputRef = ref<HTMLInputElement | null>(null);
const isDraggingTirePhoto = ref(false);
const newReceiptPhotos = ref<File[]>([]);
const deletedReceiptPhotoIds = ref<number[]>([]);
const receiptPhotoInputRef = ref<HTMLInputElement | null>(null);
const isDraggingReceiptPhoto = ref(false);
const errors = ref<Record<string, string>>({});
const showDOTHelp = ref(false);
const tirePositionOptions = ['Front Left', 'Front Right', 'Rear Left', 'Rear Right', 'Spare'];

const inputStyle = computed(() => ({
  borderColor: brandColors.value.primary,
  '--tw-ring-color': brandColors.value.primary,
  outline: 'none',
}));

const isFormValid = computed(() => {
  const currentTirePhotoCount = props.tire?.tire_photos?.length || 0;
  const remainingTirePhotos = currentTirePhotoCount - deletedTirePhotoIds.value.length + newTirePhotos.value.length;

  const currentReceiptPhotoCount = props.tire?.receipt_photos?.length || 0;
  const remainingReceiptPhotos = currentReceiptPhotoCount - deletedReceiptPhotoIds.value.length + newReceiptPhotos.value.length;

  return remainingTirePhotos >= 1 && remainingReceiptPhotos >= 1;
});

watch(
  () => props.tire,
  (newTire) => {
    if (!newTire) {
      return;
    }

    formData.value = {
      pattern: newTire.pattern,
      tire_size: newTire.tire_size,
      dot: newTire.dot,
      tire_position: newTire.tire_position || '',
      shop: newTire.shop || '',
      code: newTire.code || '',
      invoice_number: newTire.invoice_number || '',
    };
    newTirePhotos.value = [];
    deletedTirePhotoIds.value = [];
    newReceiptPhotos.value = [];
    deletedReceiptPhotoIds.value = [];
    errors.value = {};
    showDOTHelp.value = false;
  },
  { immediate: true }
);

function getPhotoUrl(path: string): string {
 const baseUrl = process.env.VUE_APP_API_URL || 'http://localhost:8000'; // live url here
 // const baseUrl = process.env.VUE_APP_API_URL?.replace('/api', '') || 'http://localhost:8000';
  return `${baseUrl}/storage/${path}`;
}

function getPreviewUrl(file: File): string {
  return URL.createObjectURL(file);
}

function handleTirePhotoDrop(event: DragEvent) {
  isDraggingTirePhoto.value = false;

  const files = Array.from(event.dataTransfer?.files || []).filter((file) =>
    ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)
  );

  if (files.length > 0) {
    processTirePhotos(files);
  }
}

function handleTirePhotoSelect(event: Event) {
  const target = event.target as HTMLInputElement;

  if (target.files) {
    processTirePhotos(Array.from(target.files));
    target.value = '';
  }
}

function processTirePhotos(files: File[]) {
  const invalidFiles = files.filter((file) => file.size > 5 * 1024 * 1024);

  if (invalidFiles.length > 0) {
    errors.value.tire_photo = 'Some files exceed 5MB limit';
    return;
  }

  errors.value.tire_photo = '';
  newTirePhotos.value.push(...files);
}

function removeNewTirePhoto(index: number) {
  newTirePhotos.value.splice(index, 1);
}

function markTirePhotoForDeletion(photoId: number) {
  if (!deletedTirePhotoIds.value.includes(photoId)) {
    deletedTirePhotoIds.value.push(photoId);
  }
}

function undoDeleteTirePhoto(photoId: number) {
  const index = deletedTirePhotoIds.value.indexOf(photoId);

  if (index > -1) {
    deletedTirePhotoIds.value.splice(index, 1);
  }
}

function handleReceiptPhotoDrop(event: DragEvent) {
  isDraggingReceiptPhoto.value = false;

  const files = Array.from(event.dataTransfer?.files || []).filter((file) =>
    ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)
  );

  if (files.length > 0) {
    processReceiptPhotos(files);
  }
}

function handleReceiptPhotoSelect(event: Event) {
  const target = event.target as HTMLInputElement;

  if (target.files) {
    processReceiptPhotos(Array.from(target.files));
    target.value = '';
  }
}

function processReceiptPhotos(files: File[]) {
  const invalidFiles = files.filter((file) => file.size > 5 * 1024 * 1024);

  if (invalidFiles.length > 0) {
    errors.value.receipt_photo = 'Some files exceed 5MB limit';
    return;
  }

  errors.value.receipt_photo = '';
  newReceiptPhotos.value.push(...files);
}

function removeNewReceiptPhoto(index: number) {
  newReceiptPhotos.value.splice(index, 1);
}

function markReceiptPhotoForDeletion(photoId: number) {
  if (!deletedReceiptPhotoIds.value.includes(photoId)) {
    deletedReceiptPhotoIds.value.push(photoId);
  }
}

function undoDeleteReceiptPhoto(photoId: number) {
  const index = deletedReceiptPhotoIds.value.indexOf(photoId);

  if (index > -1) {
    deletedReceiptPhotoIds.value.splice(index, 1);
  }
}

function handleSubmit() {
  errors.value = {};

  if (!formData.value.pattern.trim()) {
    errors.value.pattern = 'Pattern is required';
  }

  if (!formData.value.tire_size.trim()) {
    errors.value.tire_size = 'Tire size is required';
  }

  if (!formData.value.dot.trim()) {
    errors.value.dot = 'DOT code is required';
  }

  if (!formData.value.tire_position) {
    errors.value.tire_position = 'Tire position is required';
  }

  if (!formData.value.shop.trim()) {
    errors.value.shop = 'Shop/Dealer name is required';
  }

  if (!formData.value.code.trim()) {
    errors.value.code = 'Shop/Dealer code is required';
  }

  if (!formData.value.invoice_number.trim()) {
    errors.value.invoice_number = 'Invoice number is required';
  }

  const currentTirePhotoCount = props.tire?.tire_photos?.length || 0;
  const remainingTirePhotos = currentTirePhotoCount - deletedTirePhotoIds.value.length + newTirePhotos.value.length;

  if (remainingTirePhotos < 1) {
    errors.value.tire_photo = 'At least one tire photo is required';
  }

  const currentReceiptPhotoCount = props.tire?.receipt_photos?.length || 0;
  const remainingReceiptPhotos = currentReceiptPhotoCount - deletedReceiptPhotoIds.value.length + newReceiptPhotos.value.length;

  if (remainingReceiptPhotos < 1) {
    errors.value.receipt_photo = 'At least one receipt photo is required';
  }

  if (Object.keys(errors.value).filter((key) => errors.value[key]).length > 0) {
    toast.error('Please fix the errors before submitting');
    return;
  }

  emit('save', { ...formData.value }, newTirePhotos.value, deletedTirePhotoIds.value, newReceiptPhotos.value, deletedReceiptPhotoIds.value);
}

function handleClose() {
  if (!props.loading) {
    emit('close');
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.isOpen && _ctx.tire)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 overflow-y-auto",
              onClick: _withModifiers(handleClose, ["self"])
            }, [
              _cache[45] || (_cache[45] = _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }, null, -1)),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", { class: "sticky top-0 z-10 flex items-center justify-between border-b border-gray-200 bg-white px-6 py-4 dark:border-gray-700 dark:bg-black" }, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex items-center" }, [
                      _createElementVNode("div", { class: "mr-3 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/20" }, [
                        _createElementVNode("svg", {
                          class: "h-5 w-5 text-amber-600 dark:text-amber-400",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                          })
                        ])
                      ]),
                      _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white" }, "Edit Tire Registration")
                    ], -1)),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: handleClose,
                      class: "text-gray-400 transition-colors duration-200 hover:text-gray-500 dark:hover:text-gray-300"
                    }, _cache[12] || (_cache[12] = [
                      _createElementVNode("svg", {
                        class: "h-6 w-6",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M6 18L18 6M6 6l12 12"
                        })
                      ], -1)
                    ]))
                  ]),
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(handleSubmit, ["prevent"]),
                    class: "px-6 py-4"
                  }, [
                    _cache[44] || (_cache[44] = _createElementVNode("div", { class: "mb-6 flex items-start gap-3 rounded-lg border border-yellow-200 bg-yellow-50 p-4 dark:border-yellow-700 dark:bg-yellow-900/20" }, [
                      _createElementVNode("svg", {
                        class: "mt-0.5 h-5 w-5 flex-shrink-0 text-yellow-600 dark:text-yellow-400",
                        fill: "currentColor",
                        viewBox: "0 0 20 20"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                          "clip-rule": "evenodd"
                        })
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", { class: "mb-1 text-sm font-semibold text-yellow-800 dark:text-yellow-300" }, "Admin tire edit"),
                        _createElementVNode("p", { class: "text-xs text-yellow-700 dark:text-yellow-400" }, [
                          _createTextVNode(" You may update the "),
                          _createElementVNode("strong", null, "Tire Pattern"),
                          _createTextVNode(", "),
                          _createElementVNode("strong", null, "Tire Size"),
                          _createTextVNode(", "),
                          _createElementVNode("strong", null, "DOT Code"),
                          _createTextVNode(", "),
                          _createElementVNode("strong", null, "Tire Position"),
                          _createTextVNode(", "),
                          _createElementVNode("strong", null, "Shop"),
                          _createTextVNode(", "),
                          _createElementVNode("strong", null, "Code"),
                          _createTextVNode(", "),
                          _createElementVNode("strong", null, "Invoice Number"),
                          _createTextVNode(", "),
                          _createElementVNode("strong", null, "Tire Photos"),
                          _createTextVNode(", and "),
                          _createElementVNode("strong", null, "Receipt Photos"),
                          _createTextVNode(". Saving changes keeps the tire's current approval status unchanged. Changes to Shop, Code, and Invoice Number apply to this tire only. ")
                        ])
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_3, [
                      _cache[16] || (_cache[16] = _createElementVNode("h4", { class: "mb-4 text-lg font-semibold text-gray-900 dark:text-white" }, "Customer Information", -1)),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _cache[14] || (_cache[14] = _createElementVNode("p", { class: "mb-1 text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400" }, "Customer Name", -1)),
                          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.tire.user?.first_name) + " " + _toDisplayString(_ctx.tire.user?.last_name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _cache[15] || (_cache[15] = _createElementVNode("p", { class: "mb-1 text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400" }, "Email", -1)),
                          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.tire.user?.email || 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _cache[18] || (_cache[18] = _createElementVNode("h4", { class: "mb-4 text-lg font-semibold text-gray-900 dark:text-white" }, "Vehicle Information", -1)),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("p", _hoisted_11, [
                          _createTextVNode(_toDisplayString(_ctx.tire.vehicle?.vehicle_year) + " " + _toDisplayString(_ctx.tire.vehicle?.vehicle_make) + " " + _toDisplayString(_ctx.tire.vehicle?.vehicle_model) + " ", 1),
                          _createElementVNode("span", _hoisted_12, "(" + _toDisplayString(_ctx.tire.vehicle?.plate_number) + ")", 1)
                        ]),
                        _cache[17] || (_cache[17] = _createElementVNode("p", { class: "mt-2 text-xs text-gray-500 dark:text-gray-400" }, "Vehicle and brand remain read-only in admin edit.", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[26] || (_cache[26] = _createElementVNode("h4", { class: "mb-4 text-lg font-semibold text-gray-900 dark:text-white" }, "Tire Information", -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _cache[19] || (_cache[19] = _createElementVNode("p", { class: "mb-1 text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400" }, "Brand", -1)),
                          _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.tire.brand?.brand_name || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[21] || (_cache[21] = _createElementVNode("label", {
                            for: "admin-tire-position",
                            class: "mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                          }, [
                            _createTextVNode(" Tire Position "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("select", {
                            id: "admin-tire-position",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.tire_position) = $event)),
                            required: "",
                            class: "w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-gray-900 dark:border-gray-600 dark:bg-black dark:text-white",
                            style: _normalizeStyle(inputStyle.value)
                          }, [
                            _cache[20] || (_cache[20] = _createElementVNode("option", { value: "" }, "-- Select position --", -1)),
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tirePositionOptions, (pos) => {
                              return _createElementVNode("option", {
                                key: pos,
                                value: pos
                              }, _toDisplayString(pos), 9, _hoisted_17)
                            }), 64))
                          ], 4), [
                            [_vModelSelect, formData.value.tire_position]
                          ]),
                          (errors.value.tire_position)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(errors.value.tire_position), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[22] || (_cache[22] = _createElementVNode("label", {
                            for: "admin-pattern",
                            class: "mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                          }, [
                            _createTextVNode(" Tire Pattern "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "admin-pattern",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.pattern) = $event)),
                            type: "text",
                            required: "",
                            class: "w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-gray-900 dark:border-gray-600 dark:bg-black dark:text-white",
                            style: _normalizeStyle(inputStyle.value)
                          }, null, 4), [
                            [_vModelText, formData.value.pattern]
                          ]),
                          (errors.value.pattern)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(errors.value.pattern), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[23] || (_cache[23] = _createElementVNode("label", {
                            for: "admin-tire-size",
                            class: "mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                          }, [
                            _createTextVNode(" Tire Size "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "admin-tire-size",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.tire_size) = $event)),
                            type: "text",
                            required: "",
                            class: "w-full rounded-lg border border-gray-300 bg-white px-4 py-2 font-mono text-gray-900 dark:border-gray-600 dark:bg-black dark:text-white",
                            style: _normalizeStyle(inputStyle.value)
                          }, null, 4), [
                            [_vModelText, formData.value.tire_size]
                          ]),
                          (errors.value.tire_size)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(errors.value.tire_size), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("label", _hoisted_22, [
                            _cache[24] || (_cache[24] = _createElementVNode("span", null, [
                              _createTextVNode("DOT Code "),
                              _createElementVNode("span", { class: "text-red-500" }, "*")
                            ], -1)),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (showDOTHelp.value = !showDOTHelp.value)),
                              class: "text-xs text-blue-500 transition-colors hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300"
                            }, " Where is this? ")
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            id: "admin-dot",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.dot) = $event)),
                            type: "text",
                            maxlength: "20",
                            required: "",
                            class: "w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-gray-900 dark:border-gray-600 dark:bg-black dark:text-white",
                            style: _normalizeStyle(inputStyle.value)
                          }, null, 4), [
                            [_vModelText, formData.value.dot]
                          ]),
                          _createVNode(_Transition, { name: "slide-down" }, {
                            default: _withCtx(() => [
                              (showDOTHelp.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[25] || (_cache[25] = [
                                    _createElementVNode("img", {
                                      src: _imports_0,
                                      alt: "DOT Code Location on Tire",
                                      class: "w-full rounded-lg border border-gray-300 shadow-sm dark:border-gray-600"
                                    }, null, -1),
                                    _createElementVNode("p", { class: "mt-3 text-xs text-blue-700 dark:text-blue-300" }, " Look for the code following \"DOT\" on the tire sidewall. The last 4 digits represent week and year of manufacture. ", -1)
                                  ])))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          (errors.value.dot)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(errors.value.dot), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _cache[30] || (_cache[30] = _createElementVNode("h4", { class: "mb-4 text-lg font-semibold text-gray-900 dark:text-white" }, "Purchase Details", -1)),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", null, [
                          _cache[27] || (_cache[27] = _createElementVNode("label", {
                            for: "admin-shop",
                            class: "mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                          }, [
                            _createTextVNode(" Shop/Dealer's Name "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "admin-shop",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.shop) = $event)),
                            type: "text",
                            required: "",
                            class: "w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-gray-900 dark:border-gray-600 dark:bg-black dark:text-white",
                            style: _normalizeStyle(inputStyle.value)
                          }, null, 4), [
                            [_vModelText, formData.value.shop]
                          ]),
                          (errors.value.shop)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(errors.value.shop), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[28] || (_cache[28] = _createElementVNode("label", {
                            for: "admin-code",
                            class: "mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                          }, [
                            _createTextVNode(" Shop/Dealer's Code "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "admin-code",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.code) = $event)),
                            type: "text",
                            required: "",
                            class: "w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-gray-900 dark:border-gray-600 dark:bg-black dark:text-white",
                            style: _normalizeStyle(inputStyle.value)
                          }, null, 4), [
                            [_vModelText, formData.value.code]
                          ]),
                          (errors.value.code)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(errors.value.code), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _cache[29] || (_cache[29] = _createElementVNode("label", {
                            for: "admin-invoice",
                            class: "mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                          }, [
                            _createTextVNode(" Invoice Number "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "admin-invoice",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.invoice_number) = $event)),
                            type: "text",
                            required: "",
                            class: "w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-gray-900 dark:border-gray-600 dark:bg-black dark:text-white",
                            style: _normalizeStyle(inputStyle.value)
                          }, null, 4), [
                            [_vModelText, formData.value.invoice_number]
                          ]),
                          (errors.value.invoice_number)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(errors.value.invoice_number), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _cache[36] || (_cache[36] = _createElementVNode("h4", { class: "mb-4 text-lg font-semibold text-gray-900 dark:text-white" }, "Tire Photos", -1)),
                      (_ctx.tire.tire_photos?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createElementVNode("p", _hoisted_33, "Existing Tire Photos (" + _toDisplayString(_ctx.tire.tire_photos.length) + ")", 1),
                            _createElementVNode("div", _hoisted_34, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tire.tire_photos, (photo) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: photo.tire_photo_id,
                                  class: "relative"
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(['relative', deletedTirePhotoIds.value.includes(photo.tire_photo_id) ? 'opacity-50' : ''])
                                  }, [
                                    _createElementVNode("img", {
                                      src: getPhotoUrl(photo.photo_path),
                                      alt: "Tire photo",
                                      class: "h-24 w-full rounded-lg border-2 border-gray-200 object-cover dark:border-gray-600"
                                    }, null, 8, _hoisted_35),
                                    (deletedTirePhotoIds.value.includes(photo.tire_photo_id))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, _cache[31] || (_cache[31] = [
                                          _createElementVNode("span", { class: "rounded bg-white px-2 py-1 text-xs font-semibold text-red-600 dark:bg-black dark:text-red-400" }, "Will be deleted", -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                  ], 2),
                                  (!deletedTirePhotoIds.value.includes(photo.tire_photo_id))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        onClick: ($event: any) => (markTirePhotoForDeletion(photo.tire_photo_id)),
                                        class: "absolute -right-2 -top-2 rounded-full bg-red-500 p-1.5 shadow-lg transition-all duration-200 hover:scale-110 hover:bg-red-600",
                                        title: "Delete photo"
                                      }, _cache[32] || (_cache[32] = [
                                        _createElementVNode("svg", {
                                          class: "h-4 w-4 text-white",
                                          fill: "none",
                                          viewBox: "0 0 24 24",
                                          stroke: "currentColor"
                                        }, [
                                          _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M6 18L18 6M6 6l12 12"
                                          })
                                        ], -1)
                                      ]), 8, _hoisted_37))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        onClick: ($event: any) => (undoDeleteTirePhoto(photo.tire_photo_id)),
                                        class: "absolute -right-2 -top-2 rounded-full bg-blue-500 p-1.5 shadow-lg transition-all duration-200 hover:scale-110 hover:bg-blue-600",
                                        title: "Undo delete"
                                      }, _cache[33] || (_cache[33] = [
                                        _createElementVNode("svg", {
                                          class: "h-4 w-4 text-white",
                                          fill: "none",
                                          viewBox: "0 0 24 24",
                                          stroke: "currentColor"
                                        }, [
                                          _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
                                          })
                                        ], -1)
                                      ]), 8, _hoisted_38))
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("label", {
                        class: _normalizeClass([
                    'flex h-32 w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed transition-all duration-200',
                    isDraggingTirePhoto.value
                      ? 'border-green-500 bg-green-50 dark:bg-green-900/20'
                      : 'border-gray-300 bg-gray-50 hover:border-green-400 dark:border-gray-600 dark:bg-black/50 dark:hover:border-green-500'
                  ]),
                        onDragover: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (isDraggingTirePhoto.value = true), ["prevent"])),
                        onDragleave: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (isDraggingTirePhoto.value = false), ["prevent"])),
                        onDrop: _withModifiers(handleTirePhotoDrop, ["prevent"])
                      }, [
                        _cache[34] || (_cache[34] = _createElementVNode("div", { class: "flex flex-col items-center justify-center pb-6 pt-5" }, [
                          _createElementVNode("svg", {
                            class: "mb-3 h-10 w-10 text-gray-400",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                            })
                          ]),
                          _createElementVNode("p", { class: "mb-2 text-sm text-gray-500 dark:text-gray-400" }, [
                            _createElementVNode("span", { class: "font-semibold" }, "Add tire photos"),
                            _createTextVNode(" or drag and drop")
                          ]),
                          _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "JPEG, PNG, JPG (MAX. 5MB per file)")
                        ], -1)),
                        _createElementVNode("input", {
                          ref_key: "tirePhotoInputRef",
                          ref: tirePhotoInputRef,
                          type: "file",
                          accept: "image/jpeg,image/png,image/jpg",
                          multiple: "",
                          class: "hidden",
                          onChange: handleTirePhotoSelect
                        }, null, 544)
                      ], 34),
                      (errors.value.tire_photo)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(errors.value.tire_photo), 1))
                        : _createCommentVNode("", true),
                      (newTirePhotos.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _createElementVNode("p", _hoisted_41, "New photos to upload (" + _toDisplayString(newTirePhotos.value.length) + "):", 1),
                            _createElementVNode("div", _hoisted_42, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newTirePhotos.value, (photo, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `${photo.name}-${index}`,
                                  class: "group relative"
                                }, [
                                  _createElementVNode("img", {
                                    src: getPreviewUrl(photo),
                                    alt: `New tire ${index + 1}`,
                                    class: "h-24 w-full rounded-lg border-2 border-green-300 object-cover dark:border-green-600"
                                  }, null, 8, _hoisted_43),
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: ($event: any) => (removeNewTirePhoto(index)),
                                    class: "absolute right-1 top-1 rounded-full bg-red-500 p-1 opacity-0 transition-opacity duration-200 group-hover:opacity-100 hover:bg-red-600"
                                  }, _cache[35] || (_cache[35] = [
                                    _createElementVNode("svg", {
                                      class: "h-4 w-4 text-white",
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }, [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M6 18L18 6M6 6l12 12"
                                      })
                                    ], -1)
                                  ]), 8, _hoisted_44)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _cache[42] || (_cache[42] = _createElementVNode("h4", { class: "mb-4 text-lg font-semibold text-gray-900 dark:text-white" }, "Receipt Photos", -1)),
                      (_ctx.tire.receipt_photos?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _createElementVNode("p", _hoisted_47, "Existing Receipt Photos (" + _toDisplayString(_ctx.tire.receipt_photos.length) + ")", 1),
                            _createElementVNode("div", _hoisted_48, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tire.receipt_photos, (photo) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: photo.receipt_photo_id,
                                  class: "relative"
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(['relative', deletedReceiptPhotoIds.value.includes(photo.receipt_photo_id) ? 'opacity-50' : ''])
                                  }, [
                                    _createElementVNode("img", {
                                      src: getPhotoUrl(photo.photo_path),
                                      alt: "Receipt photo",
                                      class: "h-24 w-full rounded-lg border-2 border-gray-200 object-cover dark:border-gray-600"
                                    }, null, 8, _hoisted_49),
                                    (deletedReceiptPhotoIds.value.includes(photo.receipt_photo_id))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, _cache[37] || (_cache[37] = [
                                          _createElementVNode("span", { class: "rounded bg-white px-2 py-1 text-xs font-semibold text-red-600 dark:bg-black dark:text-red-400" }, "Will be deleted", -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                  ], 2),
                                  (!deletedReceiptPhotoIds.value.includes(photo.receipt_photo_id))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        onClick: ($event: any) => (markReceiptPhotoForDeletion(photo.receipt_photo_id)),
                                        class: "absolute -right-2 -top-2 rounded-full bg-red-500 p-1.5 shadow-lg transition-all duration-200 hover:scale-110 hover:bg-red-600",
                                        title: "Delete photo"
                                      }, _cache[38] || (_cache[38] = [
                                        _createElementVNode("svg", {
                                          class: "h-4 w-4 text-white",
                                          fill: "none",
                                          viewBox: "0 0 24 24",
                                          stroke: "currentColor"
                                        }, [
                                          _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M6 18L18 6M6 6l12 12"
                                          })
                                        ], -1)
                                      ]), 8, _hoisted_51))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        onClick: ($event: any) => (undoDeleteReceiptPhoto(photo.receipt_photo_id)),
                                        class: "absolute -right-2 -top-2 rounded-full bg-blue-500 p-1.5 shadow-lg transition-all duration-200 hover:scale-110 hover:bg-blue-600",
                                        title: "Undo delete"
                                      }, _cache[39] || (_cache[39] = [
                                        _createElementVNode("svg", {
                                          class: "h-4 w-4 text-white",
                                          fill: "none",
                                          viewBox: "0 0 24 24",
                                          stroke: "currentColor"
                                        }, [
                                          _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
                                          })
                                        ], -1)
                                      ]), 8, _hoisted_52))
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("label", {
                        class: _normalizeClass([
                    'flex h-32 w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed transition-all duration-200',
                    isDraggingReceiptPhoto.value
                      ? 'border-green-500 bg-green-50 dark:bg-green-900/20'
                      : 'border-gray-300 bg-gray-50 hover:border-green-400 dark:border-gray-600 dark:bg-black/50 dark:hover:border-green-500'
                  ]),
                        onDragover: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (isDraggingReceiptPhoto.value = true), ["prevent"])),
                        onDragleave: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (isDraggingReceiptPhoto.value = false), ["prevent"])),
                        onDrop: _withModifiers(handleReceiptPhotoDrop, ["prevent"])
                      }, [
                        _cache[40] || (_cache[40] = _createElementVNode("div", { class: "flex flex-col items-center justify-center pb-6 pt-5" }, [
                          _createElementVNode("svg", {
                            class: "mb-3 h-10 w-10 text-gray-400",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                            })
                          ]),
                          _createElementVNode("p", { class: "mb-2 text-sm text-gray-500 dark:text-gray-400" }, [
                            _createElementVNode("span", { class: "font-semibold" }, "Add receipt photos"),
                            _createTextVNode(" or drag and drop")
                          ]),
                          _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "JPEG, PNG, JPG (MAX. 5MB per file)")
                        ], -1)),
                        _createElementVNode("input", {
                          ref_key: "receiptPhotoInputRef",
                          ref: receiptPhotoInputRef,
                          type: "file",
                          accept: "image/jpeg,image/png,image/jpg",
                          multiple: "",
                          class: "hidden",
                          onChange: handleReceiptPhotoSelect
                        }, null, 544)
                      ], 34),
                      (errors.value.receipt_photo)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_53, _toDisplayString(errors.value.receipt_photo), 1))
                        : _createCommentVNode("", true),
                      (newReceiptPhotos.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            _createElementVNode("p", _hoisted_55, "New receipt photos to upload (" + _toDisplayString(newReceiptPhotos.value.length) + "):", 1),
                            _createElementVNode("div", _hoisted_56, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newReceiptPhotos.value, (photo, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `${photo.name}-${index}`,
                                  class: "group relative"
                                }, [
                                  _createElementVNode("img", {
                                    src: getPreviewUrl(photo),
                                    alt: `New receipt ${index + 1}`,
                                    class: "h-24 w-full rounded-lg border-2 border-green-300 object-cover dark:border-green-600"
                                  }, null, 8, _hoisted_57),
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: ($event: any) => (removeNewReceiptPhoto(index)),
                                    class: "absolute right-1 top-1 rounded-full bg-red-500 p-1 opacity-0 transition-opacity duration-200 group-hover:opacity-100 hover:bg-red-600"
                                  }, _cache[41] || (_cache[41] = [
                                    _createElementVNode("svg", {
                                      class: "h-4 w-4 text-white",
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }, [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M6 18L18 6M6 6l12 12"
                                      })
                                    ], -1)
                                  ]), 8, _hoisted_58)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: handleClose,
                        disabled: _ctx.loading,
                        class: "rounded-lg bg-gray-200 px-4 py-2 font-medium text-gray-700 transition-colors duration-200 hover:bg-gray-300 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-black dark:text-gray-300 dark:hover:bg-gray-600"
                      }, " Cancel ", 8, _hoisted_60),
                      _createElementVNode("button", {
                        type: "submit",
                        disabled: _ctx.loading || !isFormValid.value,
                        class: "flex items-center rounded-lg bg-amber-600 px-4 py-2 font-medium text-white transition-colors duration-200 hover:bg-amber-700 disabled:cursor-not-allowed disabled:opacity-50"
                      }, [
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_62, _cache[43] || (_cache[43] = [
                              _createElementVNode("circle", {
                                class: "opacity-25",
                                cx: "12",
                                cy: "12",
                                r: "10",
                                stroke: "currentColor",
                                "stroke-width": "4"
                              }, null, -1),
                              _createElementVNode("path", {
                                class: "opacity-75",
                                fill: "currentColor",
                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.loading ? 'Updating...' : 'Update Tire'), 1)
                      ], 8, _hoisted_61)
                    ])
                  ], 32)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})